<template>
  <div
      class="custom-control custom-switch custom-switch-text custom-control-inline custom-switch-color mr-0" >
    <div class="custom-switch-inner">
      <input type="checkbox" class="custom-control-input bg-info" :id="'customSwitch'+id"  v-model="statusValue"
             @change="changeStatus">
      <label class="custom-control-label" :for="'customSwitch'+id">
      </label>
    </div>
  </div>
</template>
<script>
const isActive = (value) => value === 'active' || value === true || value === 1 || value === '1'
export default {
  props: {
    status: {
      type: String
    },
    type: {
      type: String
    },
    id: {
      required: true
    },
    statusKeyId: {
      required: true
    },
    allData: {
      required: true
    },
    postKey: {
      default: 'service'
    }
  },
  data () {
    return {
      statusValue: isActive(this.status)
    }
  },
  watch: {
    status (newStatus) {
      this.statusValue = isActive(newStatus)
    }
  },
  methods: {
    changeStatus () {
      const obj = {}
      obj.status = this.statusValue ? 'active' : 'inactive'
      obj[this.statusKeyId] = this.id
      obj.type = this.type
      this.$emit('changeStatus', { payload: obj, data: this.allData, postKey: this.postKey, revert: this.revert })
    },
    revert () {
      this.statusValue = isActive(this.status)
    }
  }
}
</script>
